import React from 'react'
import { render } from "react-dom"
import App from './app.js'
import '@mattilsynet/design/styles.css'
import './scss/index.scss'

render(
    <App/>, document.getElementById("react-app")
)